import { api } from '@/config/api';

export interface AuditEntry {
  _id: string;
  actorUid: string;
  actorRole: string;
  actorName?: string;
  action: string;
  targetType: string;
  targetUid?: string;
  companyUid?: string;
  companyName?: string;
  outcome?: 'succeeded' | 'failed';
  statusCode?: number;
  method?: string;
  route?: string;
  params?: Record<string, string>;
  payload?: Record<string, unknown>;
  ip?: string;
  createdAt: string;
}

export interface AuditQuery { q?: string; actor?: string; companyUid?: string; category?: string; outcome?: '' | 'succeeded' | 'failed'; since?: string; page?: number; limit?: number }

export const auditLogService = {
  list: async (q: AuditQuery = {}) =>
    (await api.get('/super_admin/audit-log', { params: q })).data as {
      items: AuditEntry[]; total: number; page: number; limit: number; categories: Array<{ key: string; label: string }>;
    },
};
